import { CalendarEvent, google, outlook } from 'calendar-link';

export const useAddToCalendar = () => {
  const addToGoogleCalendar = (event?: CalendarEvent | null) => {
    if (!event) return;

    const url = google(event);
    window.open(url, '_blank');
  };

  const addToOutlookCalendar = (event?: CalendarEvent | null) => {
    if (!event) return;

    const url = outlook(event);
    window.open(url, '_blank');
  };

  return {
    addToGoogleCalendar,
    addToOutlookCalendar,
  };
};
